const commission = (incentive , lower , upper , amount) => {
    if(lower === 0 ){
        if(incentive !== 0){
            if(amount >= upper){          
                return [incentive , amount - upper + lower]
            }else{
                return [incentive , 0]
            }
        }else{
            if(amount < upper){
                return [0 , 0]
            }else{
                return [0 , amount]
            }
            
        }
    }else{  
        if(amount >= (upper -lower)){
            return [incentive, amount - upper + lower]
        }else{
            return [incentive , 0]
        }
    }
}


const calculate_commission = (bins, amount) => {
    let incentive = 0  
    let temp_amount = amount //150000
    bins.map(
        (bin) => {
            if(bin.upper <= temp_amount){
                incentive += bin.incentive
               
            }
        }
    )
    return incentive
  
}

export {calculate_commission}